import { deserializeXY } from "../serialization";
import { SolidifiedMob } from "./solidifiedMob";

export class SolidifiedSquid extends SolidifiedMob {
	static key = "SolidifiedSquid";

	static deserialize(data: any): SolidifiedSquid {
		const b = new SolidifiedSquid(deserializeXY(data.xy));
		b.restoreBaseFields(data);
		return b;
	}
}
